import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserLock } from '@fortawesome/free-solid-svg-icons';
import UpperNavBar from 'components/board/UpperNavBar';


const NoAccessMessage = (props) => (
    <React.Fragment>
        <div className='grid-viewport'>
            <UpperNavBar />
        </div>

        <div id="screen-no-access-message" className="panel radius-rectangle full-width-form">
            <div className="panel-header">
                <h1 className="bold-title">
                    <FontAwesomeIcon icon={faUserLock} />
                    <FormattedMessage id="NO_ACCESS_FOR_APP_USER_TITLE" />
                </h1>
            </div>
            <div className="panel-content">
                <FormattedMessage id="NO_ACCESS_FOR_APP_USER_TEXT" />
                <button className="btn-blue full-width" onClick={props.logout}>
                    <FormattedMessage id="BACK_TO_LOGIN" />
                </button>
            </div>
        </div>
    </React.Fragment>
);

export default NoAccessMessage;